var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1311",
    transform: "translate(-977 -220)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 15",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(977 220)",
    style: {
      fill: "#edf6ee"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 141"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 134"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15",
    transform: "translate(990 234)",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 9",
    d: "M508.7.665h-16.672a4.081 4.081 0 0 0-4.077 4.077V25.7a4.081 4.081 0 0 0 4.077 4.077H508.7a4.081 4.081 0 0 0 4.08-4.077V4.742A4.081 4.081 0 0 0 508.7.665m-16.672 2.718H508.7a1.36 1.36 0 0 1 1.359 1.359v7.229h-19.39V4.742a1.36 1.36 0 0 1 1.359-1.359m10.749 23.672h-4.822v-4.826h4.822zm0-7.544h-4.822v-4.822h4.822zm-12.108-4.822h4.568v4.822h-4.568zm0 11.007v-3.467h4.568v4.826h-3.209a1.36 1.36 0 0 1-1.359-1.359m18.031 1.359h-3.208V14.689h4.567V25.7a1.36 1.36 0 0 1-1.359 1.359",
    transform: "translate(504.511 233.793)",
    style: {
      fill: "#00402e"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 126",
    d: "M12.132 0v4.831H7.3V0H4.577v4.831H0v2.724h4.577v4.835H7.3V7.555h4.831v4.835h2.723V0z",
    transform: "translate(995.334 248.5)",
    style: {
      fill: "#00a61c"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalculator);
export default __webpack_public_path__ + "static/media/ico-calculator.ada6953e126baf8fd2703d9a3c1ea9d3.svg";
export { ForwardRef as ReactComponent };